import { render, staticRenderFns } from "./TabNews.vue?vue&type=template&id=2f214b07&"
import script from "./TabNews.vue?vue&type=script&lang=js&"
export * from "./TabNews.vue?vue&type=script&lang=js&"
import style0 from "./TabNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TabNews.vue"
export default component.exports